import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@toevla-webapplications/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/env.uat';

@Component({
    selector: 'ivva-no-access',
    imports: [TranslateModule, CoreModule],
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.scss']
})
export class NoAccessComponent implements OnInit {
	id: string;

	readonly RRN_APP_URL = environment.rrnAppUrl;

	private readonly route = inject(ActivatedRoute);

	ngOnInit() {
		this.id = this.route.snapshot.paramMap.get('id') as string;
	}
}
